import Nav from "component/shared/nav/Nav";
import NewsTicker from "component/shared/newsticker/NewsTicker";
import React from "react";
import { Outlet } from "react-router";

const AppLayout = () => {
 
  return (
    <>
      <Nav />
      <div className="content-project">
        <NewsTicker />
        <Outlet />
      </div>
    </>
  );
};

export default React.memo(AppLayout);
